import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { BottomNav } from './BottomNav';
import { useEffect } from 'react';
import { useCardsStore } from '../../stores/cards';
import { BmacPrompt } from '../ui/BmacPrompt';

export function AppShell() {
  const setBadge = useCardsStore((s) => s.setBadge);
  useEffect(() => {
    const onVis = () => { if (!document.hidden) setBadge(0); };
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, [setBadge]);

  return (
    <div className="flex min-h-screen flex-col bg-base text-text-primary">
      <Header />
      <main className="mx-auto w-full max-w-screen-sm flex-1 px-4 pb-28 pt-4">
        <Outlet />
      </main>
      <BottomNav />
      <BmacPrompt />
    </div>
  );
}
